import { useMsal } from '@azure/msal-react';
import { useSession } from '@Contexts/session/SessionContext';
import { Card, Separator } from '@synqo/frontend-component-library';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export const Logout = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const { update } = useSession();
    useEffect(() => {
        const doPostLogout = async () => {
            update(null);
            await instance.clearCache();
            navigate('/');
        };

        void doPostLogout();
    }, [instance, navigate, update]);

    return (
        <main className="absolute top-1/2 left-1/2" style={{ transform: 'translate(-50%, -50%)' }}>
            <Card name={'User information'} border={'withoutBorder'}>
                <h1 className="text-(--mantine-color-primary-text) text-3xl p-2">Logout erfolgreich.</h1>
                <Separator />
                <div className="m-2 text-center">Sie werden zum Login weitergeleitet.</div>
            </Card>
        </main>
    );
};
